import React from 'react';

import { Route, Routes } from 'react-router-dom';

import Layout from 'components/layout';
import CanadianTireCompleteLinking from 'pages/partner-linking/canadian-tire/complete-linking';
import CanadianTireInitiateLinking from 'pages/partner-linking/canadian-tire/initiate-linking';
import PartnerLinkingErrorPage from 'pages/partner-linking/error';
import { routes } from 'utils/routing';

/**
 * Top-level route switch. Microsites (currently the CT partner-linking
 * flow) render outside the main app shell so they don't mount AppHeader,
 * EmergencyBanner, Footer, or the bundle of Sanity feature queries that
 * `Layout` fans out on mount — cuts request count from ~127 to ~42 on
 * an authenticated landing. Everything else falls through to `Layout`.
 *
 * Add new microsite routes here as siblings; the catch-all stays last.
 */
export default function TopLevelRoutes(): JSX.Element {
  return (
    <Routes>
      <Route
        path={routes.partnerLinkingCanadianTireInitiate}
        element={<CanadianTireInitiateLinking />}
      />
      <Route
        path={routes.partnerLinkingCanadianTireCallback}
        element={<CanadianTireCompleteLinking />}
      />
      <Route path={routes.partnerLinkingError} element={<PartnerLinkingErrorPage />} />
      <Route path="*" element={<Layout />} />
    </Routes>
  );
}
